// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1uvst","list":"PatternAutocomplete_list___iCla"};